import { TableBuildingListCell } from '../../../Table'
import { toTableBuildingCellTextFromLabelTitle } from '../../DocFlow.utils.scope'

function DocFlowTableCellBuilding({ value, ...restProps }) {
  const preparedValue = value?.map(toTableBuildingCellTextFromLabelTitle)

  return <TableBuildingListCell {...restProps} value={preparedValue} />
}

export default DocFlowTableCellBuilding
